import styled from "styled-components";
import girl from "assets/images/Elle_Tiffany_2021_04_211189.gif";
import girlBw from "assets/images/Elle_Tiffany_2021_04_211055.jpg";
import girlMini from "assets/images/Elle_Tiffany_2021_04_211143.jpg";

export const Container = styled.section`
  width: 100%;
  max-width: 1342px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 128px 0;

  @media screen and (max-width: 580px) {
    padding: 80px 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 96px;

  @media screen and (max-width: 580px) {
    padding: 0 32px;
  }
`;

export const Text = styled.article`
  font-size: 28px;
  line-height: 32px;
  text-align: justify;

  @media screen and (max-width: 1680px) {
    font-size: 24px;
    line-height: 28px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 22px;
    line-height: 26px;
  }

  @media screen and (max-width: 1024px) {
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 580px) {
    font-size: 18px;
    line-height: 22px;
  }

  @media screen and (max-width: 375px) {
    font-size: 16px;
    line-height: 20px;
  }

  @media screen and (max-width: 320px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Girl = styled.img.attrs({ src: girl })`
  width: 100%;
  height: auto;
  object-fit: contain;
  margin: 128px 0;
  padding: 0 96px;

  @media screen and (max-width: 1024px) {
    padding: 0;
  }

  @media screen and (max-width: 580px) {
    margin: 80px 0;
  }
`;

export const GirlBw = styled.img.attrs({ src: girlBw })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const GirlMini = styled.img.attrs({ src: girlMini })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const PhotosWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto 128px auto;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    padding: 0 96px;
  }

  @media screen and (max-width: 580px) {
    margin-bottom: 80px;
    padding: 0 32px;
  }
`;

export const PhotoContent = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.right {
    padding: 104px;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;

    &.right {
      padding: 0;
    }
  }
`;
